import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CheyCheyActions,
  stateStatusType,
  FetchCheyCheyImageRequestAction,
  FetchCheyCheyImageSuccessAction,
  FetchCheyCheyImageFailureAction,
  CreateCheyCheyImageFailAction,
  CreateCheyCheyImageSuccessAction,
  DeleteCheyCheyImageFailAction,
  DeleteCheyCheyImageSuccessAction,
} from "./actionType";
import { CheyCheyImageState, initialState } from "./state";

//FetchCheyCheyImageRequest
const FetchCheyCheyImageRequest = (
  state: CheyCheyImageState,
  action: FetchCheyCheyImageRequestAction
) => {
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchCheyCheyImageSuccess = (
  state: CheyCheyImageState,
  action: FetchCheyCheyImageSuccessAction
) => {
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      cheyCheyImage: action.payload,
    },
  });
};

const FetchCheyCheyImageFail = (
  state: CheyCheyImageState,
  action: FetchCheyCheyImageFailureAction
) => {
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      cheyCheyImage: null,
    },
  });
};

const CreateCheyCheyImageSuccess = (
  state: CheyCheyImageState,
  action: CreateCheyCheyImageSuccessAction
) => {
  const newCheyCheyImages = state.cheyCheyImageState.cheyCheyImage ?? [];
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: false,
      cheyCheyImage: [...newCheyCheyImages, action.payload],
      error: null,
    },
  });
};
const CreateCheyCheyImageFail = (
  state: CheyCheyImageState,
  action: CreateCheyCheyImageFailAction
) => {
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const DeleteCheyCheyImageSuccess = (
  state: CheyCheyImageState,
  action: DeleteCheyCheyImageSuccessAction
) => {
  const newCheyCheyImages = state.cheyCheyImageState.cheyCheyImage?.filter((item)=> item.id !== action.payload) ?? [];
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: false,
      cheyCheyImage: [...newCheyCheyImages],
      delete:null,
      error: null,
    },
  });
};
const DeleteCheyCheyImageFail = (
  state: CheyCheyImageState,
  action: DeleteCheyCheyImageFailAction
) => {
  return updateObject(state, {
    cheyCheyImageState: {
      ...state.cheyCheyImageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      delete:action.payload
    },
  });
};
const cheyCheyImageReducer = (
  state = initialState,
  action: CheyCheyActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_CHEYCHEY_IAMGE_REQUEST:
      return FetchCheyCheyImageRequest(state, action);
    case actionTypes.FETCH_CHEYCHEY_IAMGE_SUCCESS:
      return FetchCheyCheyImageSuccess(state, action);
    case actionTypes.FETCH_CHEYCHEY_IAMGE_FAIL:
      return FetchCheyCheyImageFail(state, action);
    case actionTypes.CREATE_CHEYCHEY_IAMGE_SUCCESS:
      return CreateCheyCheyImageSuccess(state, action);
    case actionTypes.CREATE_CHEYCHEY_IAMGE_FAIL:
      return CreateCheyCheyImageFail(state, action);
    case actionTypes.DELETE_CHEYCHEY_IAMGE_SUCCESS:
      return DeleteCheyCheyImageSuccess(state, action);
    case actionTypes.DELETE_CHEYCHEY_IAMGE_FAIL:
      return DeleteCheyCheyImageFail(state, action);
    default:
      return state;
  }
};

export default cheyCheyImageReducer;
